// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inst-suggest-title[data-v-815fabf6] {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 24px;\n  padding-top: 4px;\n  color: #333333;\n}\n.inst-suggest-num[data-v-815fabf6] {\n  font-size: 12px;\n  color: #999999;\n  line-height: 24px;\n}\n.inst-suggest .el-autocomplete[data-v-815fabf6] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
